const HOSTNAME = window.location.hostname

const getEnvironment = () => {
  if (HOSTNAME.startsWith('test') || HOSTNAME === 'localhost' ) {
    return 'test'
  }
  return 'prod'
}

const environment = getEnvironment()

const API_BASE_URLS = {
  test: 'https://test.xcars.kz',
  prod: 'https://xcars.kz'
}
export const isDevelop = false
export const BaseUrl = API_BASE_URLS[environment]

export const AUTH_API_URL = `${API_BASE_URLS[environment]}/api-auth`;
export const CS_API_URL = `${API_BASE_URLS[environment]}/api-sale`;
export const CAR_API_URL = `${API_BASE_URLS[environment]}/api-car`;
export const NOTIFICATION_API_URL = `${API_BASE_URLS[environment]}/api-notification`;
export const DASHBOARD_API_URL = `${API_BASE_URLS[environment]}/api-dashboard`;
export const NEWS_API_URL = `${API_BASE_URLS[environment]}/api-news`;
